import { generateUuid } from "@/utils/index";
import { ref, computed, reactive, defineComponent, toRefs, onMounted, watch } from "vue";

import QRCode from "qrcode";
export default defineComponent({
  isGlobal: true,
  name: "QrcodeImage",
  props: {
    content: {
      type: String,
      require: true,
    },
    width: {
      type: String,
      default: "130",
    },
    height: {
      type: String,
      default: "130",
    },
  },
  setup(props, { emit }) {
    const state = reactive({
      canvasId: generateUuid(),
      url:'',
    });
    const init = () => {
      let width = props.width,
        height = props.height;
        QRCode.toDataURL( props.content).then(url=>{
          state.url = url
        });
    };
    watch(
      () => props.content,
      (n) => {
        init();
      },
      { immediate: true }
    );
    return {
      ...toRefs(state),
    };
  },
});
